<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    title="$t('organizations.join_org.enter_invitation_code')"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-form class="auth-form">
        <code-input :codeLength="6" :showLable="false" @codeChanged="handleCode"/>
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        disabled
        @click.native="handleInvite"
        ref="submit"
      >
        {{ $t('common.continue') }}
      </primary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import CodeInput from '@/components/common/CodeInput'
  import { handleSubmitButtonState, handleFormValidation } from '@/helpers/formValidationHelper'

  export default {
    components: {
      Modal,
      PrimaryButton,
      CodeInput
    },
    data() {
      return {
        form: {},
        rules: {
          email: [
            { type: 'email', message: this.$t('organizations.join_org.email_validation'), trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      handleInvite() {
        handleFormValidation(this.$refs.form, this.callback, () => {})
      },
      handleCancelClick() {
        this.$emit('closed')
      },
      handleCode(code) {
        handleSubmitButtonState(this.$refs.submit.$el, code.isValid)
      },
      callback() {
        this.$refs.form.resetFields()
        handleSubmitButtonState(this.$refs.submit.$el, true)
        this.$emit('closed')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .code {
    margin: 0;
  }

</style>
